import { MENU_ITEMS, MenuItemType } from 'appConstants';

const getMenuItems = (loggedInUser: any) => {
    let allItems = MENU_ITEMS;

    if (loggedInUser.role === 'SuperAdmin')
        return allItems;

    if (process.env.ENV === 'prod')
        allItems = allItems.filter((item) => !item.preProduction);

    allItems = allItems.filter((item: any) => !item.isEnterprise || loggedInUser.isEnterpriseCustomer)

    allItems = allItems.filter((item: any) => !item.roleRestriction || item.roleRestriction?.indexOf(loggedInUser.role));

    return allItems;
};

const findAllParent = (menuItems: MenuItemType[], menuItem: MenuItemType): string[] => {
    let parents: string[] = [];
    const parent = findMenuItem(menuItems, menuItem['parentKey']);

    if (parent) {
        parents.push(parent['key']);
        if (parent['parentKey']) parents = [...parents, ...findAllParent(menuItems, parent)];
    }

    return parents;
};

const findMenuItem = (
    menuItems: MenuItemType[] | undefined,
    menuItemKey: MenuItemType['key'] | undefined
): MenuItemType | null => {
    if (menuItems && menuItemKey) {
        for (var i = 0; i < menuItems.length; i++) {
            if (menuItems[i].key === menuItemKey) {
                return menuItems[i];
            }
            var found = findMenuItem(menuItems[i].children, menuItemKey);
            if (found) return found;
        }
    }
    return null;
};

const panelStyle: React.CSSProperties = {
    marginBottom: 24,
    padding: 0,
    background: 'none',
    borderRadius: 0,
    border: 'none',
};

export { getMenuItems, findAllParent, findMenuItem, panelStyle };
